import { SaneImage } from '@components/sanity';

export function PrebuiltComponents({ image }: any) {
  return (
    <div className="mt-10">
      <div className="relative px-4 py-12 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="relative lg:grid lg:grid-cols-3 lg:gap-x-8">
          <div className="lg:col-span-1">
            <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Use high-conversion, beautiful components
            </h2>
            <p className="max-w-3xl mt-3 text-lg text-gray-500">
              We built user management UIs so you don't have to &ndash; free in
              every plan! Mount them in React, or let Clerk host them for you.
            </p>
          </div>
          <div className="mt-10 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-8 sm:gap-y-10 lg:mt-0 lg:col-span-2">
            <div>
              <p className="mb-2 text-xl font-medium">
                <code>&lt;SignUp/&gt;</code>
              </p>
              <SaneImage
                wrapClassName="image-wrap rounded rounded-lg shadow shadow-lg"
                src={image.componentSignUp}
              />
            </div>
            <div>
              <p className="mb-2 text-xl font-medium">
                <code>&lt;SignIn/&gt;</code>
              </p>
              <SaneImage
                wrapClassName="image-wrap rounded rounded-lg shadow shadow-lg"
                src={image.componentSignIn}
              />
            </div>
            <div>
              <p className="mb-2 text-xl font-medium">
                <code>&lt;UserProfile/&gt;</code>
              </p>
              <SaneImage
                wrapClassName="image-wrap rounded rounded-lg shadow shadow-lg"
                src={image.componentUserProfile}
              />
            </div>
            <div>
              <p className="mb-2 text-xl font-medium">
                <code>&lt;UserButton/&gt;</code>
              </p>
              <SaneImage
                wrapClassName="image-wrap rounded rounded-lg shadow shadow-lg"
                src={image.componentUserButton}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
